import React from 'react';
    import { motion } from 'framer-motion';
    import SafeIcon from '../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';

    const { FiExternalLink } = FiIcons;

    const ProfileCard = ({ profile, onTagClick }) => {
        return (
            <motion.div
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                whileHover={{ y: -4 }}
                transition={{ duration: 0.2 }}
                className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden h-full flex flex-col"
            >
                <div className="p-5 flex-grow">
                    <div className="flex items-start justify-between mb-3">
                        <div>
                            <h3 className="text-base font-bold text-slate-900">{profile.name}</h3>
                            <p className="text-sm text-slate-500">@{profile.instagram_handle}</p>
                        </div>
                         <a href={`https://instagram.com/${profile.instagram_handle}`} target="_blank" rel="noopener noreferrer" className="p-1 text-slate-400 hover:text-slate-700 transition-colors">
                            <SafeIcon icon={FiExternalLink} />
                        </a>
                    </div>

                    {profile.bio && (
                        <p className="text-slate-600 mb-4 text-sm line-clamp-2">
                            {profile.bio}
                        </p>
                    )}
                </div>
                
                {(profile.tags && profile.tags.length > 0) && (
                    <div className="p-5 border-t border-slate-100">
                        <div className="flex flex-wrap gap-2">
                            {profile.tags.slice(0, 3).map((tag, index) => (
                                <button
                                    key={index}
                                    onClick={() => onTagClick(tag)}
                                    className="px-2.5 py-1 text-xs font-medium bg-slate-100 text-slate-700 hover:bg-slate-200 rounded-full transition-colors"
                                >
                                    {tag}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </motion.div>
        );
    };

    export default ProfileCard;